import $ from 'jquery';
import moment from 'moment';

// Banner functionality for top and bottom banners

// ****************************************************************
// Functions
// ****************************************************************

// Get cookie
// ----------------------------------------------------------------
function getCookie(name) {
    function escape(s) {
        return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); // eslint-disable-line
    }
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
    return match ? match[1] : null;
}

// Hashing of banner content for setting/comparing content state
// or changes
// ----------------------------------------------------------------
var hashCode = function (s) {
    return s.split("").reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0);
}

// Timeout to expire the cookie (unless content has changed based
// on hashCode)
// ----------------------------------------------------------------
const cookieExpirationStartDate = moment();
const cookieExpirationEndDate = moment(cookieExpirationStartDate);
cookieExpirationEndDate.add(3, 'months');
const cookieExpirationDate = cookieExpirationEndDate['_d'];



// ****************************************************************
// Logic
// ****************************************************************

// Top banner
// ----------------------------------------------------------------
const closeTopBannerTrigger = $('#js-closeTopBannerTrigger');
const closeTopBannerTarget = $('#js-closeTopBannerTarget');
const topBannerHashInitial = String(hashCode(closeTopBannerTarget.text()));

if (closeTopBannerTrigger.length && closeTopBannerTarget.length) {
    // Show top banners if top banner hash isn't the same as when the user
    // dismissed it or banner cookie has expired.
    if (getCookie('amnestyTopBanner') !== topBannerHashInitial) {
        closeTopBannerTarget.show();
    }

    // Close top banner on click and sets cookie and hash.
    if (closeTopBannerTrigger.on('click', function() {
        var topBannerHash = hashCode(closeTopBannerTarget.text());

        document.cookie = 'amnestyTopBanner' + "=" + topBannerHash + ';' + 'expires=' + cookieExpirationDate + ';' + 'path=/';
        closeTopBannerTarget.hide();
    }));
}

// Bottom banner
// ----------------------------------------------------------------
const closeBottomBannerTrigger = $('#js-closeBottomBannerTrigger');
const closeBottomBannerTarget = $('#js-closeBottomBannerTarget');
const bottomBannerHashInitial = String(hashCode(closeBottomBannerTarget.text()));

if (closeBottomBannerTrigger.length && closeBottomBannerTarget.length) {

    // Bandaid solution to only show bottom banner if cookie banner is not visible
    // to prevent overlap.
    setTimeout(() => {
        if (! $('.js-cookie-banner').is(':visible')) {

            // Show bottom banner if bottom banner hash isn't the same as when the user
            // dismissed it or cookie has expired.
            if (getCookie('amnestyBottomBanner') !== bottomBannerHashInitial) {
                closeBottomBannerTarget.fadeIn(100);
            }

            // Close bottom banner on click and sets cookie and hash.
            if (closeBottomBannerTrigger.on('click', function() {
                var bottomBannerHash = hashCode(closeBottomBannerTarget.text());

                document.cookie = 'amnestyBottomBanner' + "=" + bottomBannerHash + ';' + 'expires=' + cookieExpirationDate + ';' + 'path=/';
                closeBottomBannerTarget.fadeOut(100);
            }));

        }
    }, 500);
}
